import React, { FC } from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

import openNewTab from "../../../../../utils/openNewTab";

const PREFIX = "ExperimentHeader";

const classes = {
  header: `${PREFIX}-header`,
  articleLink: `${PREFIX}-articleLink`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  marginBottom: 5,
  [`& .${classes.header}`]: {
    fontSize: "22px",
    fontWeight: 600,
  },

  [`& .${classes.articleLink}`]: {
    textDecoration: "none",
    color: theme.palette.primary.main,
    "&:hover": {
      color: theme.palette.primary.dark,
      cursor: "pointer",
    },
  },
}));

interface ExperienceHeaderProps {
  title: string;
  articleLink?: string;
  linkText?: string;
}

export const ExperienceHeader: FC<ExperienceHeaderProps> = ({
  title,
  articleLink,
  linkText,
}) => {
  return (
    <StyledGrid
      container
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      paddingRight={"10px"}
    >
      <IgTypography className={classes.header}>{title}</IgTypography>
      {linkText && (
        <IgTypography variant={"body1"}>
          Need help?{" "}
          <strong
            className={classes.articleLink}
            onClick={() => {
              openNewTab(articleLink!);
            }}
          >
            {linkText}
          </strong>
        </IgTypography>
      )}
    </StyledGrid>
  );
};
